import { Icon } from '@instinet-analytics/semantic-ui-components';
import React from 'react';

export const tradedVolumeTooltip = {
    title: 'Traded Volume ',
    body: (
        <span>
            is today&apos;s market traded volume, from open until now. The
            volume bars are displayed in time bins, which can be changed in the
            chart&apos;s configuration <Icon name="cog" />.
        </span>
    ),
};
export const historicalVolumeTooltip = {
    title: 'Historical Volume ',
    body: (
        <span>
            is the market historical traded volume (averaged over the last 20
            days). The volume bars are displayed in time bins, which can be
            changed in the chart&apos;s configuration <Icon name="cog" />.
        </span>
    ),
};
export const auctionTooltip = {
    title: 'Auction Volume ',
    body: 'displays the historical market volume traded (averaged over the last 20 days) in the auction sessions. Hover over the relevant time bin to see opening, intraday or closing auction volumes.',
};
export const cumulativeHistoricalVolumeTooltip = {
    body: (
        <>
            <div>
                <span className="title">Cumulative Historical Volume </span> is
                the cumulative sum of the historical market volume (averaged
                over the last 20 days).
            </div>
            <div>
                Cumulative volume is calculated by adding all historical volume
                traded in each time bin.
            </div>
        </>
    ),
};
export const cumulativeTradedVolumeTooltip = {
    body: (
        <>
            <div>
                <span className="title">Cumulative Traded Volume </span>is the
                cumulative sum of today&apos;s market volume, from open until
                now.
            </div>
            <div>
                Cumulative volume is calculated by adding all actual volume
                traded in each time bin.
            </div>
        </>
    ),
};
